var _defs, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAnalysis = function SvgAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Analysis_svg__e5f5cf39-8c5b-4c0c-b362-97326da9fa3b",
    "data-name": "Analysis"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    d: "m129.68 143.81-17.3-17.3M171.91 112.84l-30.62 30.62M100.69 126.44 83.03 143.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    cx: 106.57,
    cy: 120.7,
    r: 8.22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    cx: 135.67,
    cy: 149.44,
    r: 8.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    cx: 177.73,
    cy: 107.03,
    r: 8.22
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    cx: 77.16,
    cy: 149.44,
    r: 8.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    d: "M49.64 61.35v118.6h155.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Analysis_svg__ad2fa95b-7219-40eb-ada5-fee5a4f05020",
    d: "m39.65 70.27 10.2-10.2 9.77 10.2M200.15 189.93l10.2-10.2-10.2-9.77"
  }))));
};

export default SvgAnalysis;